<template>
  <div class="video-popup">
    <div class="video-content">
      <template v-if="!fullScreenPlay">
        <img v-show="!isShowVideo" :src="coverUrl" alt="">
        <video v-show="isShowVideo" :id="`myVideo_${shorexBannerIndex}`"
               :src="videoUrl"
               :poster="coverUrl"
               controls
               controlsList="nodownload noremoteplayback noplaybackrate"
               playsinline
               x-webkit-airplay
               x5-video-player-type="h5"
               x5-videoplayer-fullscreen
               webkit-playsinline
               x5-video-orientation='portraint'
               style='object-fit:fill;'
               class="full-screen-video"
               @play="notFullScreenPlay"
               @ended="notFullScreenEnded"
        ></video>
        <div v-show="!notFullScreenVideoPlaying" class="videoPlayBtn" @click.stop="onChangeVideoPlay">
          <img src="https://resource.rcclchina.com.cn/paySuccess/videoBtn.png" alt="">
        </div>
      </template>
      <template v-else>
        <template v-if="isAndroid">
          <img v-show="!isShowVideo" :src="coverUrl" alt="">
          <video v-show="isShowVideo" :id="`myVideo_${shorexBannerIndex}`" :controls="false" :src="videoUrl"
                 @fullscreenchange="handleFullscreenChange"
                 :poster="coverUrl"
                 controlsList="nodownload noremoteplayback noplaybackrate"
                 disablePictureInPicture
          ></video>
        </template>
        <template v-else>
          <img :src="coverUrl" alt="">
          <video  class="video-js vjs-default-skin vjs-big-play-centered video-ios"
                  :id="`playerId_${shorexBannerIndex}`" controlsList="nodownload noremoteplayback noplaybackrate"
                  disablePictureInPicture>
            <source :src="videoUrl" />
          </video>
        </template>
        <div class="videoPlayBtn" @click.stop="onChangeVideoPlay">
          <img src="https://resource.rcclchina.com.cn/paySuccess/videoBtn.png" alt="">
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
export default {
  props: {
    videoUrl:{
      type: String,
      default: ''
    },
    coverUrl:{
      type: String,
      default: ''
    },
    videoId:{
      type: Number,
      default: 0
    },
    shorexBannerIndex:{
      type: String,
      default: ''
    },
    // 全屏播放
    fullScreenPlay: {
      type: Boolean,
      value: false
    },
    // 暂停全部播放
    pauseAllPlay: {
      type: Boolean,
      value: true
    },
    // 是否切换
    isChange: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isFullscreen: false,
      isShowVideo:false,
      videoPlayer:'',
      isAndroid: false,
      videoPlayerAndroid:'',
      notFullScreenVideoPlaying: false,
      videoPlayerFullScreen: null
    }
  },
  mounted() {
    this.isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
    if(!this.isAndroid)this.videoInit()
  },
  watch:{
    isChange(val) {
      console.log(val)
      if(val) {
        this.notFullScreenVideoPlaying = false;
        this.isShowVideo = false;
      }
    }
    // videoId(val){
    //   console.log('videoId',val)
    //   if(val){
    //     if(!this.isAndroid)this.videoInit()
    //   }
    // },
    //
    // videoUrl:{
    //   deep: true,
    //   handler (val) {
    //     if (val) {
    //       this.iosVideoUrl = val
    //       console.log('val',val)
    //       console.log('iosVideoUrl',this.iosVideoUrl)
    //     }
    //   },
    //   immediate: true
    // }
  },
  methods:{
    videoInit(){
      if(this.fullScreenPlay) {
        this.videoPlayer = videojs('playerId_'+this.shorexBannerIndex, {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: false,
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          // 设置视频播放器的显示宽度（以像素为单位）
          width: "100%",
          // 设置视频播放器的显示高度（以像素为单位）
          height: "100%",
          controlBar: {
            playToggle: true
          },

        });

        this.videoPlayer.on('fullscreenchange', ()=> {
          if(!this.videoPlayer.isFullscreen_){
            if(!this.isAndroid){
              this.videoPlayer.pause()
              this.videoPlayer.currentTime(0)
              this.isShowVideo = false
            }
          } else {
            this.onVideoStopEmit()
          }
        });
      }
    },

    //   全屏
    async fullScreen() {
      // 自动播放
      this.isShowVideo = true
      // 点击播放按钮重新添加视频url
      const video = this.videoPlayerAndroid
      video.setAttribute('src',this.videoUrl)
      // this.onVideoPlayEmit()
      video.currentTime = 0
      await video.play();
      if(this.fullScreenPlay) {
        if (!this.isFullscreen) {
          await this.enterFullscreen();
        } else {
          this.exitFullscreen();
        }
      }
    },
    // 进入全屏逻辑
    async enterFullscreen() {
      if(!this.fullScreenPlay) return;
      const video = this.videoPlayerAndroid
      if (video.requestFullscreen) {
        await video.requestFullscreen();
      } else if (video.mozRequestFullScreen) { // Firefox
        await video.mozRequestFullScreen();
      } else if (video.webkitRequestFullscreen) { // Chrome, Safari 和 Opera
        await video.webkitRequestFullscreen();
      } else if (video.msRequestFullscreen) { // IE/Edge
        await video.msRequestFullscreen();
      }
    },
    // 退出全屏逻辑
    exitFullscreen() {
      if(!this.fullScreenPlay) return;
      const video = this.videoPlayerAndroid
      if (video.exitFullscreen) {
        video.exitFullscreen();
      } else if (video.mozCancelFullScreen) {
        video.mozCancelFullScreen();
      } else if (video.webkitExitFullscreen) {
        video.webkitExitFullscreen();
      } else if (video.msExitFullscreen) {
        video.msExitFullscreen();
      }
      this.isFullscreen = false;
      this.onVideoStopEmit()
    },
    handleFullscreenChange() {
      // 更新全屏状态
      this.isFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
      if(!this.isFullscreen){
        this.videoPlayerAndroid.pause()
        this.isShowVideo = false
      }
    },
    onChangeVideoPlay(){
      if(this.fullScreenPlay) {
        this.onVideoPlayEmit();
        if(!this.isAndroid){
          this.isShowVideo = true
          this.videoPlayer.src(this.videoUrl);
          this.videoPlayer.play()
        }else{
          this.videoPlayerAndroid = document.getElementById(`myVideo_${this.shorexBannerIndex}`);
          this.fullScreen()
        }
      } else {
        this.videoPlayerFullScreen = document.getElementById(`myVideo_${this.shorexBannerIndex}`);
        this.videoPlayerFullScreen.currentTime = 0;
        setTimeout(()=> {
          this.videoPlayerFullScreen.play();
        },100)
      }
    },
    // 播放视频触发事件
    onVideoPlayEmit(){
      this.$emit('onVideoPlay')
    },
    onVideoStopEmit() {
      this.$emit('onVideoStop')
    },
    // 非全屏播放
    notFullScreenPlay() {
      this.notFullScreenVideoPlaying = true;
      this.isShowVideo = true;
    },
    notFullScreenEnded() {
      this.notFullScreenVideoPlaying = false;
      this.isShowVideo = false;
    }
  }
}
</script>
<style scoped lang="less">
.video-popup{
  width: 100%;
  height: 100%;
}
.video-content{
  width: 100%;
  height: 100%;
  position: relative;
  & video{
    width: 100%;
    height: 100%;
    display: block;
  }
  & img{
    width: 100%;
    height: 100%;
    display: block;
    position: relative;
    z-index: 2;
  }
  & .videoPlayBtn{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 42px;
    height: 42px;
    transform: translate(-50%, -50%);
    z-index: 3;
    & img{
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}
.video-ios {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  z-index: 1;
  &.no-full-screen {
    opacity: 1;
  }
}
.full-screen-video {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
</style>